import { render, staticRenderFns } from "./AuthorityDeleteProvider.vue?vue&type=template&id=d362b972&scoped=true&"
import script from "./AuthorityDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./AuthorityDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362b972",
  null
  
)

export default component.exports